import { render } from "./NewCropFieldCertification.vue?vue&type=template&id=8d44328c"
import script from "./NewCropFieldCertification.vue?vue&type=script&lang=js"
export * from "./NewCropFieldCertification.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/crop_field_certification.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fcertifications%2Fproviders%2FNewCropFieldCertification.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/views/agro_exporter/certifications/providers/new_crop_field_certification.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fcertifications%2Fproviders%2FNewCropFieldCertification.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__